import dashboardPanelView from "Modules/dashboard/views/dashboardPanel/lan/es";

const locales = {
    ...dashboardPanelView
};

export default locales;